module.exports = __webpack_public_path__ + "bc3bd03b387019ad1c1dc83f58973004.png";